(ns frontend.view.entity-viewers.activity.events
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.actions.entity :as entity-actions]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.subscription :as subscription]
   [frontend.utils :as fu]
   [frontend.view.modals.choice-confirmation.view :as choice-confirmation]
   [frontend.view.modals.dynamic.view :as dynamic-modal]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.notification.view :as notification]
   [reagent.core :as r]
   [ui.color :as c]
   [ui.components.button.view :as button]
   [ui.editors.data-input :as data-input]))

(defn delete-entity!
  [local-entities entity-id on-success! on-error!]
  (let [current-state (or (get @session/entities entity-id)
                          (get @local-entities entity-id))]
    (when (and current-state (not (:common/disabled? current-state)))
      (entity-actions/*->disable! entity-id
                                  (fn [_]
                                    (swap! session/entities dissoc entity-id)
                                    (when local-entities
                                      (swap! local-entities dissoc entity-id))
                                    (on-success!))
                                  (fn [err]
                                    (logging/error "Failed to disable entity " entity-id " -> " err)
                                    (on-error!))))))

(defn remove-relationship
  [local-entities activity-entity-id related-id on-success! on-error!]
  (let [activity-entity-atom (r/cursor local-entities [activity-entity-id])
        current-relations (:common/related-entities @activity-entity-atom)
        updated-relations (disj (set current-relations) related-id)]
    (if (and current-relations (get current-relations related-id))
      (entity-actions/*->field-update!
       activity-entity-id
       :common/related-entities
       updated-relations
       (fn [_]
         (swap! activity-entity-atom assoc :common/related-entities updated-relations)
         (on-success!))
       (fn [_err]
         (when (= updated-relations (get @activity-entity-atom :common/related-entities))
           (swap! activity-entity-atom assoc :common/related-entities current-relations))
         (on-error!)))
      (logging/log "No current relations : " current-relations " ->> " related-id))))

(defn remove-action-relationship
  [local-entities activity-entity-id related-id on-success! on-error!]
  (modals/open-modal!
   notification/modal-key
   {:body-text      (loc/tr :confirm-remove-action-relationship-text)
    :ok-button-text (loc/tr :confirm-remove-action-relationship-button)
    :title          (loc/tr :confirm-remove-action-relationship-title)
    :on-ok!         (fn [_]
                      (remove-relationship local-entities
                                           activity-entity-id
                                           related-id
                                           on-success!
                                           on-error!))}))

(defn start-edit-date
  [nev-entity-id entity]
  (let [edit-atom (r/atom {:common/created-on (:common/created-on entity)})]
    (modals/open-modal!
     dynamic-modal/modal-key
     {:title               (loc/tr :edit-date)
      :show-button?        false
      :close-button        false
      :button-text         (loc/tr :cancel)
      :button-class        "zap-btn__solid__yellow"
      :on-submit!          (fn [_]
                             (reset! edit-atom true))
      :custom-validator-fn (constantly nil)
      :render-fn
      (fn [_state close-modal!]
        [:div
         {:class "flex flex-col gap-2"}
         [data-input/view
          {:data-type    :data.type/datetime
           :value        (:common/created-on @edit-atom)
           :on-change    (fn [new-value]
                           (swap! edit-atom assoc :common/created-on new-value))
           :full-width?  true
           :transparent? true
           :variant      :underline
           :date-format  (get @session/tenant :tenant/date-format "dd.MM.yyyy")}]
         [:div
          {:class "flex flex-row"}
          [:div
           {:class "flex-auto justify-items-end"}
           [button/primary-solid
            {:on-click  (fn [_]
                          (entity-actions/*->field-update!
                           (if (= :system-activity.type/create (:system-activity/type entity))
                             nev-entity-id
                             (:db/id entity))
                           :common/created-on (:common/created-on @edit-atom)
                           close-modal!
                           (fn [_resp]
                             (js/console.log "Failed to update date"))))
             :disabled? (= (:common/created-on @edit-atom)
                           (:common/created-on entity))}
            (loc/tr :save)]]]])})))

(defn exclude-from-reporting
  [nev-entity-id entity]
  (entity-actions/*->field-update! (:db/id entity) :common/exclude-from-reporting? (not (:common/exclude-from-reporting? entity))
                                   identity
                                   (fn [_esp]
                                     (js/console.log "Failed to exclude reporting"))))

(defn dropdown-remove-selected
  [local-entities action-entity-id nev-entity-id on-success! on-error!]
  (let [related-atom (r/cursor session/entities [nev-entity-id])
        current-relations (:common/related-entities (get @local-entities action-entity-id))
        action-entity (session/get-entity action-entity-id)
        value-creation-parent-entity? (when (= :entity.type/value-creation (:entity/type action-entity))
                                        (= nev-entity-id (:value-creation/parent-entity action-entity)))]
    (cond
      (and (not value-creation-parent-entity?)
           (> (count current-relations) 1))
      (modals/open-modal!
       choice-confirmation/modal-key
       {:body                 (loc/tr :confirm-note-no-undo)
        :body-position        :bottom
        :accept-false?        true
        :confirm-button-color ::c/danger
        :confirm-text         (loc/tr :confirm-delete-button-remove-action)
        :radio-text-no        (loc/tr :confirm-delete-action-remove-single-relationship
                                [(loc/tr (:entity/type @related-atom))
                                 (entity/display-string @related-atom)])
        :radio-text-yes       (loc/tr :confirm-delete-action-remove-everywhere)
        :on-confirm           (fn [args]
                                (if (true? args)
                                  (delete-entity! local-entities action-entity-id on-success! on-error!)
                                  (remove-relationship local-entities
                                                       action-entity-id
                                                       nev-entity-id
                                                       on-success!
                                                       on-error!)))})
      (or value-creation-parent-entity?
          (= (count current-relations) 1))
      (modals/open-modal!
       notification/modal-key
       {:body-text          (loc/tr :confirm-note-no-undo)
        :ok-button-text     (loc/tr :confirm-delete-button-remove-action)
        :cancel-button-text (loc/tr :cancel)
        :title              (loc/tr :confirm-delete-title-remove-action)
        :ok-button-color    ::c/danger
        :on-ok!             (fn [_]
                              (delete-entity! local-entities
                                              action-entity-id
                                              on-success!
                                              on-error!))})

      (nil? current-relations)
      (delete-entity! local-entities action-entity-id on-success! on-error!))))

(defn pin-selected
  [_action-entity-id _viewed-entity-id _on-success! _on-error!]
  (logging/error "Not implemented PIN"))

(defn open-history-subscription!
  [{:keys [entity-ids primary-entity-id state]}]
  (subscription/close
   ::timeline-entity
   (fn [_close-resp]
     (let [subs-state (atom {})]
       (subscription/open ::timeline-entity
                          :timeline-entity
                          {:entity-ids        entity-ids
                           :primary-entity-id primary-entity-id
                           :max-count         (get @state :max-count 50)}
                          (fn [resp]
                            (when-not (:unmounted? @state)
                              (let [initial-loaded? (fu/manage-subscription-response
                                                     subs-state
                                                     resp
                                                     state
                                                     true
                                                     identity)]
                                (when (and initial-loaded?
                                           (not (:timeline-loaded @state)))
                                  (swap! state assoc :timeline-loaded true))
                                (deref state)
                                (deref session/session)
                                :ok)))
                          (fn [error]
                            (swap! state assoc :error error)
                            :ok))))))

(defn open-emails-subscription!
  [{:keys [entity-ids primary-entity-id state]}]
  (subscription/close
   ::entity-emails
   (fn [_close-resp]
     (let [subs-state (atom {})]
       (subscription/open ::entity-emails
                          :entity-emails
                          {:entity-ids        entity-ids
                           :primary-entity-id primary-entity-id
                           :max-count         (get @state :max-count 50)}
                          (fn [resp]
                            (when-not (:unmounted? @state)
                              (fu/manage-subscription-response
                               subs-state
                               resp
                               state
                               false
                               (fn [entities]
                                 (->> entities
                                      (filter (fn [entity]
                                                (some #{(:entity/type entity)}
                                                      [:entity.type/email
                                                       :entity.type/attachment]))))))
                              (when-not (:timeline-loaded @state)
                                (swap! state assoc :timeline-loaded true))
                              (deref state)
                              (deref session/session)
                              :ok))
                          (fn [error]
                            (swap! state assoc :error error)
                            :ok))))))

(defn open-audit-subscription!
  [{:keys [primary-entity-id state]}]
  (subscription/close
   ::audit-history-entity
   (fn [_close-resp]
     (subscription/open ::audit-history-entity
                        :audit-history-entity
                        {:primary-entity-id primary-entity-id}
                        (fn [resp]
                          (let [updates (:entities resp)
                                timeline-entities (->> updates
                                                       (cu/only-entity
                                                        :entity.type/history-attribute-change))]
                            (swap! state assoc
                                   :audit-timeline-rows
                                   (concat (:audit-timeline-rows @state) timeline-entities))
                            (when-not (:audit-timeline-loaded @state)
                              (swap! state assoc :audit-timeline-loaded true))
                            @state
                            :ok))
                        (fn [error]
                          (swap! state assoc :error error)
                          :ok)))))

(defn stop-history-subscription!
  [state]
  (swap! state assoc :unmounted? true)
  (subscription/close ::timeline-entity))

(defn stop-emails-subscription!
  [state]
  (swap! state assoc :unmounted? true)
  (subscription/close ::entity-emails))

(defn stop-audit-subscription!
  [state]
  (swap! state assoc :unmounted? true)
  (subscription/close ::audit-history-entity)
  (when state
    (swap! state dissoc :audit-timeline-rows)))
